"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testProductItem = {
    name: 'testProductItemName',
    productId: 'testProductItemId',
    productType: 'membership-type',
    variants: [
        {
            id: 1,
            isMaster: true,
        },
    ],
    published: true,
    subscriptionProductType: {
        key: 'membership',
        label: 'membership',
    },
    showQuantity: false,
};
//# sourceMappingURL=index.js.map